import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import HeartDefaultRegular from 'jl-ui-kit/elements/icons/HeartDefaultRegular';
// eslint-disable-next-line import/no-named-as-default
import AccountButton from '../account-button/AccountButton';
import AccountMenu from '../account-menu/AccountMenu';
import formatGreeting from '../../utils/user/format-greeting';
import { isDesktop, isTouchDevice } from '../../utils/device/identifyDevice';
import { UserContext } from '../../scaffold/UserContext';
import { getAccountLinks } from '../links';

import styles from './account-links.scss';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';

const AccountLinks = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    envVars: { accountBaseUrl },
  } = useContext(EnvVarsFeaturesContext);
  const {
    userState: {
      user: { signedIn, greeting },
    },
  } = useContext(UserContext);

  const toggleMenu = e => {
    e.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  const formattedGreeting = formatGreeting(greeting);
  const displayedGreeting =
    formattedGreeting === '' ? 'My account' : `Hello ${formattedGreeting}`;

  const accountLinks = getAccountLinks(accountBaseUrl);

  return (
    <div className={styles.container}>
      {signedIn ? (
        <div
          className={classNames(styles.menuTrigger)}
          data-test="menu-triggers"
          onMouseEnter={e => !isTouchDevice() && toggleMenu(e)}
          onMouseLeave={e => !isTouchDevice() && toggleMenu(e)}
        >
          <div className={styles.account}>
            <AccountButton
              data-test="account-button"
              onClick={e => isTouchDevice() && isDesktop() && toggleMenu(e)}
              greeting={displayedGreeting}
            />
            <AccountMenu isOpen={isMenuOpen} accountLinks={accountLinks} />
          </div>
        </div>
      ) : (
        <>
          <div className={classNames(styles.signIn, styles.desktop)}>
            <a href="/sign-in">Sign in</a>
          </div>
          <AccountButton />
        </>
      )}
      <a
        href={`${accountBaseUrl}/wish-list`}
        className={classNames(styles.icon, styles.desktop)}
        data-test="wishlist-button"
        data-testid="wishlist-button"
        aria-label="View your wishlist"
      >
        <HeartDefaultRegular box />
      </a>
    </div>
  );
};

export default AccountLinks;
